import { defineMessages } from 'react-intl';

/**
 * The copy of the account card and the account menu (design navigation-v2 1a, 1d, 6a) and of the
 * mobile account sheet (7d). The rows Settings, Connections and Help and support reuse the
 * navigation labels.
 */
export const accountMenuMessages = defineMessages({
  menu: { id: 'app.sml.account.menu', defaultMessage: 'Account menu' },
  owner: { id: 'app.sml.account.role.owner', defaultMessage: 'Owner' },
  member: { id: 'app.sml.account.role.member', defaultMessage: 'Member' },
  roleAndPlan: { id: 'app.sml.account.roleAndPlan', defaultMessage: '{role} · {plan}' },
  planAndArtists: {
    id: 'app.sml.account.planAndArtists',
    defaultMessage: '{plan} · {count, plural, one {# artist} other {# artists}}',
  },
  plansAndBilling: { id: 'app.sml.account.plansAndBilling', defaultMessage: 'Plans and billing' },
  theme: { id: 'app.sml.account.theme', defaultMessage: 'Theme' },
  themeDark: { id: 'app.sml.account.theme.dark', defaultMessage: 'Dark' },
  themeLight: { id: 'app.sml.account.theme.light', defaultMessage: 'Light' },
  mobileApp: { id: 'app.sml.mobileApps.navItem', defaultMessage: 'Get the mobile app' },
  logOut: { id: 'app.sml.account.logOut', defaultMessage: 'Log out' },
  // design 7d: the line under the name in the mobile account sheet.
  sheetLine: { id: 'app.sml.account.sheet.line', defaultMessage: '{email} · {plan}' },
});
